import { Moment } from "moment";
import { User } from "./subscriptionsManager";
import { PaginationInterfaceLF } from ".";

export interface ClientIdentityApiResponse {
  data: ClientIdentity;
  included: {
    users: ClientIdentityUsers[];
  };
}

export interface ClientIdentityUsers {
  userId: number;
  name: string;
  email: string;
}
export interface PhoneIdentities {
  number: string;
  status: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface ClientIdentityLogs {
  userId: number;
  description: string;
  action: string;
  createdAt: Date;
  user?: ClientIdentityUsers; // This is not part of the API response , added from FE
}
export interface ClientIdentity {
  clientId: number;
  identityId: number;
  userId: number;
  email: string;
  activationStatus: string;
  lastAccessDate: string;
  createdAt: string;
  phoneIdentities: PhoneIdentities[];
  logs: ClientIdentityLogs[];
}

export interface MobileNumbersInterface {
  number: string;
  kind: string;
}

export interface ClientAllergiesItem {
  allergyItemId: number;
  createdAt: string;
}

export interface AllergiesItem {
  allergyItemId: number;
  createdAt: string;
  name: string;
}
export interface ClientAllergyIncludedItem {
  id: number;
  name: string;
}

export interface GetClientAllergiesApiResponse {
  data: ClientAllergiesItem[];
  included: {
    allergicItems: ClientAllergyIncludedItem[];
  };
}
export interface Client {
  id: number;
  referenceNumber: string;
  gender: string;
  civilId: number | null;
  birthDate: string | null;
  maritalStatus: string | null;
  nationality: string | null;
  numberOfChildren: number | null;
  weight: number | null;
  height: number | null;
  targetWeight: number | null;
  dietGoal: number | null;
  bodyFat: number | null;
  name: string;
  email: string;
  higherCaloriesLimit: number;
  lowerCaloriesLimit: number;
  isProfileComplete: boolean;
  medicalRecords: any[]; // TODO: Need to find its types
  mobileNumbers: MobileNumbersInterface[];
  clientAllergies: ClientAllergiesItem[];
}

export interface ClientAddress {
  id: number;
  clientId: number;
  latitude: number;
  longitude: number;
  block: string;
  street: string;
  avenu: string;
  districtId: number;
  area: string;
  buildingNumber: string;
  floorNumber: string;
  roomNumber: string;
  phoneNumber: string;
  title: string;
}
export interface DietPreferenceApiResponse {
  data: DietPreference[];
}
export interface DietPreference {
  type: string;
  extraChargePercentage: number;
  createdAt: string;
  updatedAt: string;
}
export interface UpdateDietPreferenceApiResponse {
  preferredDiets: string[];
}

interface MobileNumber {
  kind: string;
  number: string;
}

interface ClientDetail {
  id: number;
  referenceNumber: string;
  name: string;
  email: string;
  civilId: string | null;
  birthDate: string | null;
  gender: string | null;
  maritalStatus: string | null;
  numberOfChildren: number | null;
  nationality: string | null;
  height: number | null;
  weight: number | null;
  targetWeight: number | null;
  dietGoal: string | null;
  lowerCaloriesLimit: number;
  higherCaloriesLimit: number;
  isProfileComplete: boolean;
  mobileNumbers: MobileNumber[];
}

export interface UserDetailType {
  client: ClientDetail;
  startDate: Moment;
}
export interface ClientDeliveryAddressLog {
  id: number;
  action: string;
  description: string;
  userId: number;
  createdAt: string;
  details:string;
  actionBy?: string;
}
export interface ClientDeliveryAddressLogsApiResponse {
  data: ClientDeliveryAddressLog[];
  included?: {
    users: User[];
  };
  pagination: PaginationInterfaceLF;
}

export enum ClientAction {
  AddAddress = "AddAddress",
  UpdateAddress = "UpdateAddress",
}
